import { Injectable } from "@angular/core";
import { Document } from "../../domain/document";
import { GenericService } from "../../../core/commons/generic.service";
import { AuthService } from "../../../core/security/auth.service";
import { QueryOptions } from "../../../core/commons/query.options";
import { DocumentCategory } from "../../domain/documentCategory";
import { Observable } from "rxjs/Observable";
import {
  BaseRequestOptions,
  Headers,
  RequestMethod,
  RequestOptions,
  ResponseContentType,
  URLSearchParams
} from "@angular/http";
import { environment } from "../../../../environments/environment";
import { Keyword } from "../../domain/keyword";

@Injectable()
export class DocumentService extends GenericService<Document> {
  constructor(public authService: AuthService) {
    super(authService);
  }

  protected valueToEntity(value: Object): Document {
    return new Document(value);
  }

  protected valueToEntityK(value: Object): Keyword {
    return new Keyword(value);
  }

  protected getResourcePath(): string {
    return "/repository";
  }

  public getDefaultQueryOptions(): QueryOptions {
    return new QueryOptions();
  }

  public getLastDocuments(): Observable<Document[]>{
    let req = {
      url: environment.backendHost +
      environment.backendPublicApiPath +
      this.getResourcePath() +
      "/getLastDocuments",
      method: RequestMethod.Get
    };
    let options = new BaseRequestOptions();
    options = options.merge(req);
    options.headers.append("Content-Type", "application/json");

    return this.authService
      .publicRequest(options.url, options)
      .map(res => res.json().map(t => this.valueToEntity(t)));
  }

  public getByCategory(c: DocumentCategory): Observable<Document[]> {
    let req = {
      url:
        environment.backendHost +
        environment.backendPublicApiPath +
        this.getResourcePath() +
        "/by-category/" +
        c.id,
      method: RequestMethod.Get
    };
    let options = new BaseRequestOptions();
    options = options.merge(req);
    options.headers.append("Content-Type", "application/json");

    return this.authService
      .publicRequest(options.url, options)
      .map(res => res.json().map(t => this.valueToEntity(t)));
  }

  public uploadPDF(file: File, name: string): Observable<any> {
    let formData: FormData = new FormData();
    formData.append("file", file, name);
    const headers = new Headers({});
    headers.set("Authorization", localStorage.getItem(environment.tokenName));
    let options = new RequestOptions({ headers });

    return this.authService.http.post(
      this.baseUrl + this.getResourcePath() + "/upload",
      formData,
      options
    );
  }

  public downloadPDF(fileID: string): Observable<any> {
    let req = {
      url:
        environment.backendHost +
        environment.backendPublicApiPath +
        this.getResourcePath() +
        "/file/" +
        fileID,
      method: RequestMethod.Get
    };
    let options = new BaseRequestOptions();
    options = options.merge(req);
    options.responseType = ResponseContentType.Blob;

    return this.authService.publicRequest(options.url, options).map(res => {
      return new Blob([res.blob()], { type: "application/pdf" });
    });
    /**

        const headers = new Headers({});
        headers.set("Authorization", localStorage.getItem(environment.tokenName));
        let options = new RequestOptions({ headers: headers, responseType : ResponseContentType.Blob});
        return this.authService.http.get(this.baseUrl+this.getResourcePath()+"/file/"+fileID, options)
            .map( res => {
                return new Blob([res.blob()], { type: 'application/pdf' });
            });
         */
  }

  public findByValueAndCategory(
    value: string,
    categoryID: any
  ): Observable<Document[]> {
    let req = {
      url:
        environment.backendHost +
        environment.backendPublicApiPath +
        this.getResourcePath() +
        "/find",
      method: RequestMethod.Get
    };
    let options = new BaseRequestOptions();
    options = options.merge(req);
    options.headers.append("Content-Type", "application/json");
    options.params = new URLSearchParams();
    options.params.set("value", value);
    if (categoryID != null) {
      options.params.set("category", categoryID);
    }

    return this.authService
      .publicRequest(options.url, options)
      .map(res => res.json().map(t => this.valueToEntity(t)));
  }

  public findBykeyWord(value: string): Observable<Keyword[]> {
    let req = {
      url:
        environment.backendHost +
        environment.backendPublicApiPath +
        this.getResourcePath() +
        "/keyword/find",
      method: RequestMethod.Get
    };
    let options = new BaseRequestOptions();
    options = options.merge(req);
    options.headers.append("Content-Type", "application/json");
    options.params = new URLSearchParams();
    options.params.set("value", value);

    return this.authService
      .publicRequest(options.url, options)
      .map(res => res.json().map(t => this.valueToEntityK(t)));
  }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/service/repository/document.service.ts